import React, { useState, useEffect } from 'react';

import { Row } from 'xpi-black-ui/Base/Grid';
import Loading from 'xpi-black-ui/Base/Loading';
import Dropdown from 'xpi-black-ui/Common/Dropdown';
import { DialogHeader } from 'xpi-black-ui/Common/Dialog';
import DialogOverlay from 'xpi-black-ui/Common/Dialog/compose/Overlay';

import { blockScroll, unblockScroll } from 'xpi-black-ui/Utils/helpers';
import { convertPDF } from 'utils/helpers';

import waConfig from 'utils/waConfig';

import Dialog, { DialogWrapper, DialogContent } from './styles';

const ModalPush = ({ pushHtml, onClose, ...otherProps }) => {
  const [loadingPage, setLoadingPage] = useState(false);

  useEffect(() => {
    blockScroll();
    return () => unblockScroll();
  }, []);

  const content = pushHtml.response.replace(/.*(<\/head>)|(?=<script)/s, ' ').replace('</body>', '').replace('</html>', '');
  const style = pushHtml.response.replace(/<\/head>.*/s, '').replace(/(.*)stylesheet\'>/s, '').trim();

  return (
    <Dialog {...otherProps} overlayClick={onClose}>
      <DialogOverlay overlayClick={onClose} />
      <DialogWrapper>
        <DialogHeader title="Proposta visualizada pelo cliente" onClose={onClose} />
        <DialogContent>
          <Row justifyContent="flex-end">
            <Dropdown
              title="Exportar"
              data-wa={waConfig.event.proposalCenter.exportPush}
              items={[{
                text: 'PDF',
                link: () => {
                  convertPDF(pushHtml.response,
                    `proposta-${pushHtml.operationId}`,
                    () => { setLoadingPage(true) },
                    () => { setLoadingPage(false) })
                }
              }]}
            />
          </Row>
          <div  dangerouslySetInnerHTML={{ __html: style }} />
          <style>
            {"\ #push-content div, #push-content span.text { color: #151617;\ "}
          </style>
          <div id='push-content' dangerouslySetInnerHTML={{ __html: content }} />
        </DialogContent>
      </DialogWrapper>
      {loadingPage && <Loading text="Carregando..." fixed />}
    </Dialog>
  );
}

export default ModalPush;
